const JsonDecodeInput = () => null;

export default JsonDecodeInput;
